import { render, staticRenderFns } from "./TuitionFeePostCreate.vue?vue&type=template&id=7125e3a7&scoped=true"
import script from "./TuitionFeePostCreate.vue?vue&type=script&lang=js"
export * from "./TuitionFeePostCreate.vue?vue&type=script&lang=js"
import style0 from "./TuitionFeePostCreate.vue?vue&type=style&index=0&id=7125e3a7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7125e3a7",
  null
  
)

export default component.exports